import React from 'react';
import {
  Modal,
  Button,
  Typography,
  Box
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { tokens } from '../../Common/designTokens';

const AccountDeletedModal = ({ open, onClose, deletedAccount }) => {
  const handleClose = () => {
    onClose();
  };

  if (!deletedAccount) return null;

  // Common modal style matching OrderConfirmationModal (light theme)
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    bgcolor: tokens.colors.bodyBackgroundColor, // switched to light background
    border: `1px solid ${tokens.colors.bodyBorderColor50}`,
    boxShadow: 24,
    p: 4,
    borderRadius: "8px", // <-- changed from 1
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="account-deleted-modal"
    >
      <Box sx={modalStyle}>
        <Typography 
          id="account-deleted-modal-title" 
          variant="h6" 
          component="h2" 
          sx={{ color: tokens.palette.danger, mb: 2, textAlign: 'center', fontWeight: 'bold' }}
        >
          Account Deleted
        </Typography>
        
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <InfoIcon sx={{ fontSize: 48, color: tokens.palette.danger }} />
        </Box>
        
        <Typography variant="subtitle1" sx={{ color: tokens.colors.fontColour, textAlign: 'center', mb: 2 }}>
          This account has been deleted
        </Typography>
        
        <Typography variant="body2" sx={{ mb: 1, color: tokens.colors.fontColour, textAlign: 'center' }}>
          <strong>Account:</strong> {deletedAccount.description || deletedAccount.accountIdentifier || 'Unknown'}
        </Typography>
        
        <Typography variant="body2" sx={{ mb: 1, color: tokens.colors.fontColour, textAlign: 'center' }}>
          <strong>Account Number:</strong> {deletedAccount.accountIdentifier || 'Unknown'}
        </Typography>
        
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button 
            variant="contained"
            onClick={handleClose}
            sx={{ 
              textTransform: "none", 
              fontWeight: "700", 
              backgroundColor: tokens.palette.primary,
              '&:hover': { backgroundColor: tokens.palette.primaryA80 },
              width: '120px',
              color: tokens.colors.white
            }}
          >
            OK
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};


export default AccountDeletedModal;
